import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nb from "./locales/nb";
import en from "./locales/en";
import dk from "./locales/dk";
import "./i18n/usedTranslationKeys";
const supported = ["nb", "en", "dk"];

const API_TO_I18N: Record<string, string> = {
  da: "dk",
  no: "nb",
};

function toI18nKey(code: string): string {
  const base = code.split("-")[0];
  return API_TO_I18N[base] ?? base;
}

const resolvedLng = (() => {
  const stored = localStorage.getItem("lng");
  if (stored) {
    const key = toI18nKey(stored);
    if (supported.includes(key)) {
      // Normalize stale API codes (e.g. "da-DK") to bundle keys (e.g. "dk")
      if (key !== stored) localStorage.setItem("lng", key);
      return key;
    }
  }

  const nav = (navigator.languages && navigator.languages[0]) || navigator.language || "nb";
  const base = String(nav).split("-")[0];
  const chosen = supported.includes(toI18nKey(nav)) ? toI18nKey(nav) : supported.includes(base) ? base : "nb";

  localStorage.setItem("lng", chosen);
  return chosen;
})();

const languages = { nb, en, dk };

i18n
  .use(initReactI18next)
  .init({
    lng: resolvedLng,
    fallbackLng: "nb",
    // Remove ns: ["ns.translate"] and defaultNS: "ns.translate"
    // List your actual namespaces here or leave empty to load dynamically
    ns: Object.keys(en),
    defaultNS: "common", // Optional: set a default file
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  })
  .then();

// Register each imported file as a separate namespace
Object.keys(languages).forEach((lang) => {
  const bundle = languages[lang as keyof typeof languages];
  Object.keys(bundle).forEach((ns) => {
    i18n.addResourceBundle(lang, ns, bundle[ns as keyof typeof bundle], true, true);
  });
});

export default i18n;
